import styled from 'styled-components';
import clearfix from '../mixins/clearfix';
import Row from '../components/Row';

const FormRow = styled(Row)`
    margin-bottom: 24px;
    ${clearfix}
`;

export { FormRow as default, FormRow };
